import { FormHeader, FormSection } from '@atlaskit/form';
import { EntitlementIcon, formattedV2 } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { NEW_DESIGN_DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import { NOT_AVAILABLE, isDeletedEntitlement, isDeletionPendingEntitlement } from '@atlassian/cssxp-utils-entitlement';
import { defaultTo } from 'lodash';
import React from 'react';

interface Props {
  entitlement: EntitlementDetails;
}

export const ViewDeletedProductDataDetails = ({ entitlement }: Props) => {
  const { deletedProductDetails } = entitlement;

  return (
    <>
      <div data-testid="view-product-details-tab">
        <FormHeader title="Product details">
          {!!entitlement.productId && (
            <EntitlementIcon productId={entitlement?.productId} isCloud={true} className="avatar medium" />
          )}
          <h4 style={{ display: 'inline' }}>{`${defaultTo(entitlement?.productName, 'Unnamed product')} ${
            entitlement?.entitlementNumber
          }`}</h4>
          &nbsp;&nbsp;
        </FormHeader>
      </div>

      <div className="add-line-item view-quote">
        <FormSection>
          <label className={'scheduled-label'}>Status</label>
          <div className={'disabled-div'}>
            {isDeletedEntitlement(entitlement) ? 'Deleted successfully' : 'Deletion pending'}
          </div>
        </FormSection>
        <FormSection>
          <label className={'scheduled-label'}>Date placed</label>
          <div className={'disabled-div'}>
            {deletedProductDetails?.datePlaced ? (
              <formattedV2.FormattedDate dateFormat={NEW_DESIGN_DATE_FORMAT} date={deletedProductDetails?.datePlaced} />
            ) : (
              <div className="data-unavailable">{NOT_AVAILABLE}</div>
            )}
          </div>
        </FormSection>
        {!isDeletionPendingEntitlement(entitlement) && (
          <FormSection>
            <label className={'scheduled-label'}>Deleted on</label>
            <div className={'disabled-div'}>
              {deletedProductDetails?.deletedOn ? (
                <formattedV2.FormattedDate
                  dateFormat={NEW_DESIGN_DATE_FORMAT}
                  date={deletedProductDetails?.deletedOn}
                />
              ) : (
                <div className="data-unavailable">{NOT_AVAILABLE}</div>
              )}
            </div>
          </FormSection>
        )}
        <FormSection>
          <label className={'scheduled-label'}>Actioned by</label>
          <div className={'disabled-div'}>{deletedProductDetails?.author ?? NOT_AVAILABLE}</div>
        </FormSection>
        <FormSection>
          <label className={'scheduled-label'}>Support ticket link</label>
          <div className={'disabled-div'}>{deletedProductDetails?.supportTicket ?? 'N/A'}</div>
        </FormSection>
        <FormSection>
          <label className={'scheduled-label'}>Internal comment</label>
          <div className={'disabled-div'}>{deletedProductDetails?.internalComment ?? 'N/A'}</div>
        </FormSection>
      </div>
    </>
  );
};

export default ViewDeletedProductDataDetails;
